import { NavigateFunction } from 'react-router-dom'

export const setSuccessPayment = (result: any, navigate: NavigateFunction, version?: string) => {
  navigate(version ? '/new/thank-you' : '/thank-you', {
    state: { res: result },
  })
}
